import { useLazyQuery } from "@apollo/client";
import { Matter } from "@design-system";
import { TEXT_FILTER_MATTERS } from "../../graphql/query";
import { FindFilteredClients, FilterArg, FindFilteredClientsVariables } from "../../graphql/types";

import { TextFilterMattersQuery, TextFilterMattersQueryVariables } from "../../gql/graphql";

type PaginationOptions = {
  offset: number;
  limit: number;
};

type QueryOptions = PaginationOptions & {
  filter: FilterArg;
};

export type MatterFilterData = {
  matters: Matter[];
  total: number;
  queryVars: QueryOptions;
  search: (search: string) => void;
  fetchMore: () => void;
  loading: boolean;
};

export const useTextFilteredMattersLazy = (limit: number = 10) => {
  const [
    getMatters,
    {
      data: matterData,
      loading,
      error,
      fetchMore: fetchMoreRaw,
      variables = { offset: 0, limit: 0, filter: { name: [""] } },
    },
  ] = useLazyQuery<TextFilterMattersQuery, TextFilterMattersQueryVariables>(TEXT_FILTER_MATTERS);
  const matters = (matterData?.textFilteredMatters?.matters as unknown as Matter[]) || [];

  const total = matterData?.textFilteredMatters?.total || 0;
  return {
    matters,
    total,
    loading,
    error,
    fetchMore: () => {
      fetchMoreRaw &&
        fetchMoreRaw({
          variables: {
            offset: matters?.length || 0,
          },
        });
    },
    search: (search: string) => {
      getMatters({
        variables: {
          filter: { search },
          //   offset: 0,
          //   limit,
        },
      });
    },
    queryVars: variables as QueryOptions,
  };
};
